import { IconName } from '@optimus-web/icons';
import { LocalizedText, useAdaChatBotContext } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { NavbarIconButton } from '../../../components';

export const AdaChatBotButton = () => {
    const { start, isStarted, isChatButtonHidden, showChatButton } = useAdaChatBotContext();
    const handleClick = async () => {
        if (!isStarted) {
            await start();
        } else if (isChatButtonHidden) {
            showChatButton();
        }
    };

    return (
        <NavbarIconButton
            icon={IconName.CustomerSuccess}
            title={<LocalizedText textKey={TextKey.HelpCenterButtonTooltip} />}
            onClick={handleClick}
        />
    );
};
